import BaseCollection from './BaseCollection';
import Product from '../../../product';

export class Wishlist extends BaseCollection {
  super() {
    return this.super();
  }

  getProductList(className) {
    this.products = [];
    const ProductList = document.querySelectorAll(className);
    Array.prototype.filter.call(ProductList, (el) => {
      if (el.querySelector('input[type="checkbox"]:checked') === null) {
        const product = new Product(el);
        this.products.push(product);
        this.increase(product);
      }
    });
    return this;
  }
}
